import { render, staticRenderFns } from "./elementEditDialog.vue?vue&type=template&id=7bf5331e&scoped=true&"
import script from "./elementEditDialog.vue?vue&type=script&lang=js&"
export * from "./elementEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./elementEditDialog.vue?vue&type=style&index=0&id=7bf5331e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf5331e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VDialog,VIcon,VImg,VSheet})
